import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton QueryClient so prefetch (navigation, hover) and the React tree
 * share the same cache — instant repeat visits and warm navigations to /place/:name.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 30 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
